import { Link } from "@reach/router";
import { Typography } from "antd";
import React from "react";
import { Trans } from "react-i18next";
import QRImage from "react-qr-image";

import { Employee } from "../../store";

const styles = {
  container: {},
  code: {
    fontSize: 30,
    textAlign: "center" as const,
    fontFamily:
      "SFMono-Regular,Consolas,Liberation Mono,Menlo,Courier,monospace",
  },
};

interface Props {
  employee: Employee;
  onCancel?: () => void;
}
const InvitationDetail = (props: Props) => {
  const { employee } = props;
  const { name, invitation } = employee;
  const { code, deeplink } = invitation || {};
  return (
    <div style={styles.container}>
      <Typography.Paragraph>
        <Trans>Dear {name},</Trans>
      </Typography.Paragraph>
      <Typography.Paragraph>
        <Trans>
          You are invited to the Hack Harvest workorder app. You can download
          the app from the <a href={deeplink}>Apple App Store</a> or{" "}
          <a href={deeplink}>Google Play Store</a>. To get access to you can use
          the following invitation code:
        </Trans>
      </Typography.Paragraph>
      <Typography.Paragraph>
        <span style={styles.code}>{code}</span>
      </Typography.Paragraph>
      <Typography.Paragraph>
        <Trans>
          If you have problems or questions please contact{" "}
          <Link to="mailto:info@hackharvest.com">info@hackharvest.com</Link>
        </Trans>
      </Typography.Paragraph>
      <Typography.Paragraph>
        <QRImage text={deeplink} />
      </Typography.Paragraph>
      <Typography.Paragraph>
        <Trans>Best Regards</Trans>,
      </Typography.Paragraph>
      <Typography.Paragraph>
        <Trans>Hack Harvest</Trans>
      </Typography.Paragraph>
    </div>
  );
};

export default InvitationDetail;
